import { render, staticRenderFns } from "./Mb1Svg.vue?vue&type=template&id=cb6e8f74&scoped=true"
import script from "./Mb1Svg.vue?vue&type=script&lang=js"
export * from "./Mb1Svg.vue?vue&type=script&lang=js"
import style0 from "./Mb1Svg.vue?vue&type=style&index=0&id=cb6e8f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6e8f74",
  null
  
)

export default component.exports